<template>
  <div class="layout-nav">
    <div class="layout-nav-container">
      <div
        class="nav-item"
        v-for="(item, i) in menuArray"
        :key="i"
        :style="{ background: item.active ? '#f40622' : '' }"
        @click="changeNav(item, i)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {};
  },
  computed: {
    menuArray() {
      return this.$store.state.menuState.menu;
    },
  },
  methods: {
    changeNav(item, index) {
      if (this.$route.path === item.href) {
        return;
      }
      if (item.children && item.children.length > 0) {
        window.sessionStorage.setItem("activeKey", item.children[0].id);
        this.$store.commit("menuState/setActiveKey", item.children[0].id);
        window.sessionStorage.setItem("currentNav", JSON.stringify(item.children[0]));
        this.$store.commit("menuState/setCurrentNav", item.children[0]);
      }
      this.$router.push(item.href);
      // let newMenuArray = [...this.menuArray];
      // for (let i = 0; i < newMenuArray.length; i++) {
      //   if (item.href === newMenuArray[i].href) {
      //     newMenuArray[i].active = true;
      //   } else {
      //     if (item.href !== "/detail" && item.href !== "/more") {
      //       newMenuArray[i].active = false;
      //     }
      //   }
      // }
      // this.$store.commit("menuState/setMenu", newMenuArray);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
